export default __webpack_public_path__ + "static/media/ai02.2ad39278.png";